import React from 'react';
import {
    Table,
    Row,
    Spin,
    Col,
    Tabs,
    Card,
    Collapse,
} from 'antd';
const { Column } = Table;
import { getProxyInfo, getProxyRepeatInfo, getAgentsProxyInfo,actions} from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import Charts from './echarts';
import AgentChart from './agentCharts';
import VennChart from './venn';
const TabPane = Tabs.TabPane;
const Panel = Collapse.Panel;

let columnsGroupCommon = [{
    title: '代理名称',
    dataIndex: 'time',
    key: 'time',
}];
let columnsGroupExp = [{
    title: '时间',
    dataIndex: 'time',
    key: 'time',
}];
let columnsGroup = [
    {
        title: 'IP总数',
        dataIndex: 'ipDistinctCount',
        key: 'ipDistinctCount',
    },
    {
        title: '黑名单个数',
        dataIndex: 'blackIpCount',
        key: 'blackIpCount',
    },
    {
        title: '交叉数',
        dataIndex: 'repeatCount',
        key: 'repeatCount',
    },
    {
        title: '交叉数比率%',
        dataIndex: 'ratio',
        key: 'ratio',
    },
    {
        title: '曝光使用IP总量',
        dataIndex: 'evTotal',
        key: 'evTotal',
    },
    {
        title: '失败率%',
        dataIndex: 'evErrorR',
        key: 'evErrorR',
    },
    {
        title: '点击使用IP总量',
        dataIndex: 'clickTotal',
        key: 'clickTotal',
    },
    {
        title: '失败率%',
        dataIndex: 'clickErrorR',
        key: 'clickErrorR',
    },
    {
        title: '实时带宽',
        dataIndex: 'bandWidth',
        key: 'bandWidth',
        render: (text, record, index) => {
            if(text!=undefined) {
                return text + 'M';
            }else{
                return '';
            }
        }
    },
    {
        title: '区域',
        dataIndex: 'area',
        key: 'area',
    },
];
class AgencyAnalysis extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        // 解决同时请求三个接口，后端返回不准确问题
        this.props.getAgentsProxyInfo()
            .then(() => {
                this.props.getProxyInfo();
            })
    };
    updateType = (value) => {
        this.props.updateType(parseInt(value));
    };
    expend = (expanded, record) => {
        // console.log(expanded, record);
    };

    render() {
        let { proxyinfo, proxyrepeatinfo, uiStatus, agentsGroup } = this.props;
        let { list } = proxyrepeatinfo;
        // console.log('agentsGroup====', agentsGroup)
        let {isLoading, isRepeatLoading, isAgentLoading} = uiStatus;

        const columns = [
            {
                title: '时间',
                dataIndex: 'time',
                key: 'time',
            },
            {
                title: 'IP数',
                dataIndex: 'ipCount',
                key: 'ipCount',
            },
            {
                title: '使用IP数',
                dataIndex: 'usedCount',
                key: 'usedCount',
            },
            {
                title: '新增IP数',
                dataIndex: 'ipDistinctCount',
                key: 'ipDistinctCount',
            },
            {
                title: '新增IP率%',
                dataIndex: 'ratio',
                key: 'ratio',
            },
            {
                title: '使用IP总量',
                dataIndex: 'total',
                key: 'total',
            },
            {
                title: '失败率%',
                dataIndex: 'totalErrorR',
                key: 'totalErrorR',
            },
            {
                title: '曝光使用IP总量',
                dataIndex: 'evTotal',
                key: 'evTotal',
            },
            {
                title: '失败率%',
                dataIndex: 'evErrorR',
                key: 'evErrorR',
            },
            {
                title: '点击使用IP总量',
                dataIndex: 'clickTotal',
                key: 'clickTotal',
            },
            {
                title: '失败率%',
                dataIndex: 'clickErrorR',
                key: 'clickErrorR',
            },
            {
                title: '黑名单个数',
                dataIndex: 'blackIpCount',
                key: 'blackIpCount',
            },
            {
                title: '代理商',
                dataIndex: 'agent',
                key: 'agent',
            },
            {
                title: '区域',
                dataIndex: 'area',
                key: 'area',
            },
        ];

        let columnsGroupNew = [...columnsGroupCommon, ...columnsGroup];
        const expandedRowRender = record => {
            // console.log('expandedRowRender=====')
            let columnsNew = [...columnsGroupExp, ...columnsGroup];
            let data = record.detail;
            // console.log('detail=====', data)
            const rowKey = function(record) {
                return record.time; // 比如你的数据主键是 uid
            };
            return <Table columns={columnsNew} dataSource={data} pagination={false} rowKey={rowKey} />;
        };
        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>
                <Tabs defaultActiveKey="1" onChange={this.updateType}>
                    <TabPane tab="各代理商分时数据" key="1" >
                        <Row><AgentChart /></Row>
                        <Spin spinning={isAgentLoading} tip="加载中" >
                            <Table
                                columns={columnsGroupNew}
                                dataSource={agentsGroup}
                                expandedRowRender={record => expandedRowRender(record)}
                                pagination={false}
                            />
                        </Spin>
                    </TabPane>
                    <TabPane tab="代理商汇总分时数据" key="2">
                        <Row gutter={4}>
                            <Charts />
                        </Row>
                        <Spin spinning={isLoading} tip="加载中" >
                            <Table dataSource={proxyinfo} columns={columns} pagination={false}/>
                        </Spin>
                    </TabPane>
                    {/* <TabPane tab="代理商交叉数" key="3">
                        <Card title="代理交叉数" style={{marginTop: '20px', width: '800px'}}>
                            <VennChart />
                        </Card>
                    </TabPane> */}
                </Tabs>
                <Spin spinning={isRepeatLoading} tip="加载中">
                    <Card title="代理交叉数" style={{marginTop: '20px'}}>
                        <VennChart />
                    </Card>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    proxyinfo: state.agencyAnalysis.proxyinfo,
    proxyrepeatinfo: state.agencyAnalysis.proxyrepeatinfo,
    uiStatus: state.agencyAnalysis.uiStatus,
    agentsGroup: state.agencyAnalysis.agentsGroup,
});
const mapDispatchToProps = dispatch => ({
    getProxyInfo: () => dispatch(getProxyInfo()),
    getProxyRepeatInfo: () => dispatch(getProxyRepeatInfo()),
    getAgentsProxyInfo: () => dispatch(getAgentsProxyInfo()),
    updateType: value => dispatch(actions.updateType(value)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AgencyAnalysis);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/agencyAnalysis/index.js